import ApiService from '../util/apiService';
import * as ActionType from './types/ProductActionTypes';

const requestProductByLook = () => ({
  type: ActionType.REQUEST_DEFAULT_GIFT_CARD_BY_LOOK_KEY,
});

const receivedProductByLookKey = (response) => ({
  type: ActionType.RECEIVED_DEFAULT_GIFT_CARD_BY_LOOK_KEY,
  payload: response,
});

const requestProducts = () => ({
  type: ActionType.REQUEST_PRODUCTS,
});

const requestKittedProducts = () => ({
  type: ActionType.REQUEST_KITTED_PRODUCTS,
});

const receivedProducts = (response) => ({
  type: ActionType.RECEIVED_PRODUCTS,
  payload: response,
});

const receivedKittedProducts = (response) => ({
  type: ActionType.RECEIVED_KITTED_PRODUCTS,
  payload: response,
});

const requestProductByLookKey = (key) => (dispatch) => {
  dispatch(requestProductByLook());
  return ApiService.get(`/web-registry-api/v1/product/${key}`).then((json) =>
    dispatch(receivedProductByLookKey(json))
  );
};

const requestProductsByProductIds = (data) => (dispatch) => {
  dispatch(requestProducts());
  return ApiService.post('/web-registry-api/v1/product/find-products', data).then((json) =>
    dispatch(receivedProducts(json))
  );
};

const requestKittedProductByKey = (key) => (dispatch) => {
  dispatch(requestKittedProducts());
  return ApiService.get(`/web-registry-api/v1/product/get-kitted/${key}`).then((json) =>
    dispatch(receivedKittedProducts(json))
  );
};

export { requestProductByLookKey, requestProductsByProductIds, requestKittedProductByKey };
